import { createTrackingUtils } from "..";

const utils = createTrackingUtils({
  name: "flights_apex_web_bf_cta_visibility_v2",
  stages: {
    main: 1, // Users viewing fare with at least 2 priority features
    ddot: 2,
    mdot: 3,
    view_two_pf_fare: 4,
    view_three_plus_pf_fare: 5,
    select_two_plus_pf_fare: 6
  },
  goals: { hover_info_icon: 1, tap_info_button: 2 },
  defaultStage: 1
});

const trackStages = (isMobile: boolean, priorityFeaturesCount: number) => {
  isMobile ? utils.stages.mdot() : utils.stages.ddot();

  if (priorityFeaturesCount === 2) {
    utils.stages.view_two_pf_fare();
  }
  if (priorityFeaturesCount >= 3) {
    utils.stages.view_three_plus_pf_fare();
  }
};

export default { ...utils, trackStages };
